import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";
// adjust path as per your project

// ✅ Async thunk to fetch user profile
export const getUserProfile = createAsyncThunk(
  "user/getUserProfile",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      // if (!token) throw new Error("No authentication token found");

      if (!token) {
        return rejectWithValue("NO_TOKEN");
      }

      const response = await axios.get(apiEndpoints.getUserInfo, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; // return data to reducer
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch user info"
      );
    }
  }
);

export const getMusicCreators = createAsyncThunk(
  "user/getMusicCreators",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      // if (!token) throw new Error("No authentication token found");

      if (!token) {
        return rejectWithValue("NO_TOKEN");
      }

      const response = await axios.get(apiEndpoints.getMusicCreators, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; // return data to reducer
    } catch (error) {
      console.error("Error fetching user profile:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch user info"
      );
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "user/updateUserProfile",
  async (payload, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      // if (!token) throw new Error("No authentication token found");

      if (!token) {
        return rejectWithValue("NO_TOKEN");
      }

      const response = await axios.post(apiEndpoints.updateUserProfile,payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; // return data to reducer
    } catch (error) {
      console.error("Error updating user profile:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update user info"
      );
    }
  }
);

// ✅ Slice
const userProfileSlice = createSlice({
  name: "userProfile",
  initialState: {
    user: null,
    loading: false,
    error: null,
    musicCreators:null,
    updateProfileResponse:null
  },
  reducers: {
    clearUserProfile: (state) => {
      state.user = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMusicCreators.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMusicCreators.fulfilled, (state, action) => {
        state.loading = false;
        state.musicCreators = action.payload;
      })
      .addCase(getMusicCreators.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.updateProfileResponse = action.payload;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// ✅ Exports
export const { clearUserProfile } = userProfileSlice.actions;
export default userProfileSlice.reducer;
